import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)
const routes = [
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Register/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login/index.vue')
  },
  {
    path: '/news-detail-view/:rowKey',
    name: 'news-detail-view',
    component: () => import('../views/DetailView/newsDetailView.vue')
  },
  {
    path: '/',
    name: 'app',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard/index.vue')
      },
      {
        path: '/online-search',
        name: 'online-search',
        component: () => import('../views/OnlineSearch/index.vue'),
        meta: {
          alive: true
        }
      },
      {
        path: '/home',
        name: 'home',
        redirect: '/dashboard'
      },
      {
        path: '/test',
        name: 'Test',
        component: () => import('../views/Test/Condition.vue')
      }
    ]
  }
]
const router = new VueRouter({
  routes
})

export default router
